import PropTypes from 'prop-types';
import Button from 'client/components/aria/Button/Button';
import { VisuallyHidden } from 'react-aria';
import Icon from '@mdi/react';
import { mdiDownload } from '@mdi/js';
import styles from './WorkpackDownloadButton.module.scss';

const WorkpackDownloadButton = ({ children, className, variant, iconOnly, ...props }) => {
    const classes = [styles.button, iconOnly && styles.iconOnly, className].filter(Boolean).join(' ');

    return (
        <Button className={classes || undefined} variant={variant} {...props}>
            <span className={styles.content}>
                {iconOnly
                    ? <VisuallyHidden>{children}</VisuallyHidden>
                    : <span>{children}</span>
                }
                <Icon
                    path={mdiDownload}
                    size={0.75}
                    aria-hidden="true"
                    focusable="false"
                    className={styles.icon}
                />
            </span>
        </Button>
    );
};

WorkpackDownloadButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.string,
    iconOnly: PropTypes.bool
};

export default WorkpackDownloadButton;
